import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { parseDateString } from '@co-3/ctrl-ui/common';
import { CtrlIconsModule } from '@co-3/ctrl-ui/icons';
import { isBefore, isSameDay } from 'date-fns';
import { SharedModule } from '../../../../shared/shared.module';
import { ContractWidget } from '@models/contract-widgets';
import { Contract } from '@models/contract';
import { DamageReportButtonComponent } from '../../../../customer-portal/components';
import { ProductsService } from 'app/products/products.service';
import { hasTag } from 'app/products/fns';

@Component({
    selector: 'app-electronics-b2c-information-widget',
    imports: [CtrlIconsModule, SharedModule, DamageReportButtonComponent],
    templateUrl: './electronics-b2c-information-widget.component.html',
    styleUrl: './electronics-b2c-information-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectronicsB2CInformationWidgetComponent implements ContractWidget {
    private productsService = inject(ProductsService);

    public contract = input.required<Contract>();

    private product = computed(() => this.productsService.getCanonicalByInsuranceType(this.contract().insuranceType));

    protected hasContractStarted = computed(() => {
        const contractFrom = parseDateString(this.contract().contractFrom, 'dd.MM.yyyy');
        const now = new Date();
        return isBefore(contractFrom, now) || isSameDay(contractFrom, now);
    });

    protected settlementPeriodString = computed(() => {
        switch (this.contract().insuranceType.settlementPeriod) {
            case 'year':
                return 'jährlich';
            case 'month':
                return 'monatlich';
        }
    });

    protected theftProtectionString = computed(() => {
        if (hasTag(this.product(), 'hasTheftCoverage')) {
            return 'Mit Diebstahlschutz';
        } else {
            return 'Ohne Diebstahlschutz';
        }
    });

    protected deductibleString = computed(() => {
        if (hasTag(this.product(), 'hasDeductible')) {
            return 'mit Selbstbeteiligung';
        } else {
            return 'ohne Selbstbeteiligung';
        }
    });
}
